import { Calendar } from "primereact/calendar";
import { Controller } from "react-hook-form";
import styles from "../../style.module.scss";

const FormCalendar = ({
    name, control, errors, required = false, disabled = false,
    label = "", placeholder = "", selectionMode = "single"
}) => (
    <div className={`p-d-flex p-flex-column ${styles.formFieldContainer}`}>
        {label !== "" && <label className={required ? styles.requiredLabel : ""} htmlFor={name}>{label}</label>}
        <Controller name={name}
                    control={control}
                    rules={required ? {required: "Поле обязательно для заполнения"} : undefined}
                    render={({field}) => (
                        <Calendar id={name}
                                  className={errors[name] ? "p-invalid" : undefined}
                                  value={field.value}
                                  onChange={(e) => field.onChange(e.value)}
                                  onBlur={field.onBlur}
                                  inputRef={field.ref}
                                  disabled={disabled}
                                  placeholder={placeholder}
                                  dateFormat="dd.mm.yy"
                                  selectionMode={selectionMode}
                                  {...field}
                        />
                    )}
        />
        {errors[name] && <small className="p-error">{errors[name].message}</small>}
    </div>
);

export default FormCalendar;